import React, { FC, useEffect, useState } from 'react';
import { Button } from '../components/Button';
import { DirectoryBar } from '../components/DirectoryBar';
import { H3 } from '../components/H3';
import { H5 } from '../components/H5';
import { useHistory, useParams } from 'react-router-dom';
import queryString from 'query-string';
import {
  getNotUserOrderDetail,
  getOrderHistory,
  getOrderHistoryDetail,
  getOrders,
  orderConfirm,
} from '../apis/orders';
import { OrderHistorySearchOption, OrderResult, OrderSummary, TOrderDetail } from '../types/types';
import moment from 'moment';
import { stringToDate, swapPayMethod } from '../utils/texts';
import { useUserDispatch, useUserState } from '../context/UserContext';
import { Bridge } from "../plugins/bridge";
import ReactPixel from '../plugins/facebookPixel';
import { BRAZE_EVENT } from "../constants/braze";
import { getUserInfo } from "../apis/user";
import gtag from '../plugins/gtag';
import NaverPixel from '../plugins/naverPixel';
//import Logger from '../plugins/logger';
import { TargetingGates } from '../plugins/targetingGates';
import KakaoPixel from '../plugins/kakao';
import { ButtonEventProperties } from '../types/amplitudeEventProperties';
import { getCarts } from '../apis/products';
import { AIRBRIDGE_EVENT } from '../constants/airbridge';
import { isMobile } from 'react-device-detect';
import {iamportPaymentConfirm, iamportPaymentMobileConfirm} from "../apis/iamport";


function onClicKeepShopping(page : string){
  const buttonEventProperties : ButtonEventProperties = {
      button_page : page
  }

  Bridge.sendAmplitude('keep_shopping_button_clicked', buttonEventProperties);
  Bridge.sendBraze(BRAZE_EVENT.KEEP_SHOPPING_BUTTON_CLICKED, buttonEventProperties);

}

export const CartPaymentSuccessPage = () => {
  const { mobile } = useParams<{ mobile: string }>();
  const history = useHistory();
  const paymentData = queryString.parse(history.location.search);
  // @ts-ignore
  const [orderResult, setOrderResult] = useState<OrderResult>();
  const { isLoggedIn } = useUserState();
  const userDispatch = useUserDispatch();
  const [orders, setOrders] = useState<OrderSummary[]>([]);

  useEffect(() => {
    getUserInfo().then(r => userDispatch({
      type: 'LOGIN',
      payload: r.data.payload
    })).catch(e => userDispatch({ type: 'LOGOUT' }));
  }, [])

  useEffect(() => {
      if (paymentData.imp_success === 'false' || paymentData.resultMessage !== '') {
          (!!paymentData.resultMessage || !!paymentData.error_msg) && alert(paymentData.resultMessage || paymentData.error_msg);
      }
    if (isLoggedIn !== undefined) {
      if (mobile === 'mobile' && paymentData.imp_uid) {

        iamportPaymentMobileConfirm('carhartt', {
            imp_uid: paymentData.imp_uid as string,
            merchant_uid: paymentData.merchant_uid as string,
            imp_success: paymentData.imp_success === 'true',
        }).then(r => {
            getMobileDetailInfo(r.data.payload.orderNumber);
        });

      } else if (paymentData.imp_uid) {
        iamportPaymentConfirm({imp_uid: paymentData.imp_uid as string, merchant_uid: paymentData.merchant_uid as string}).then(r => {
          setOrderResult(r.data.payload);
          const getDetail = isLoggedIn ? getMemberDetail : getNonMemberDetail;
          getDetail(r.data.payload.orderNumber).then(r => {
            sendDataToBraze(r.data.payload);
            orderCompleted(r.data.payload);
            let content_ids = [];
            for (let product of r.data.payload.products){
              content_ids.push(product.productId);
            }
            ReactPixel.purchase(content_ids, r.data.payload.totalPrice); // pc purchase event
            NaverPixel.purchase(r.data.payload.totalPrice);
            //Logger.purchase(r.data.payload.products);
            gtag.ads.conversionActions.purchase(r.data.payload.totalPrice); // pc purchase event
            gtag.ads.conversionActions.paymentSuccess(r.data.payload.totalPrice); // google ads event
            KakaoPixel.Purchase(r.data.payload);
          }).catch(e => console.log(e));
        }).catch(e => {
          if (e.response.status === 400) {
            history.replace('/cart');
          }
        });
      }
    }
  }, [isLoggedIn, history.location]);

  const getMobileDetailInfo = (orderNumber: string) => {
      const getDetail = isLoggedIn ? getMemberDetail : getNonMemberDetail;
        // @ts-ignore
        getDetail(orderNumber)
          .then(r => {
            const data = r.data.payload;
            setOrderResult({
              expiredAt: data.virtualAccountValid,
              orderNumber: data.orderNumber,
              orderedAt: data.orderedAt!,
              payMethod: data.payMethod,
              productNames: `${data.products[0].productName}외 ${data.products.length - 1
                }개`,
              totalPrice: data.totalPrice,
              virtualAccountBank: data.virtualAccountBank,
              virtualAccountNumber: data.virtualAccountNumber,
              virtualAccountOwner: data.virtualAccountOwner,
            });
            sendDataToBraze(data);
            let content_ids = [];
            for (let product of data.products){
              content_ids.push(product.productId);
            }
            ReactPixel.purchase(content_ids, data.totalPrice); // mobile purchase event
            //Logger.purchase(data.products);
            NaverPixel.purchase(data.totalPrice);
            gtag.ads.conversionActions.purchase(data.totalPrice); // mobile purchase event
            gtag.ads.conversionActions.paymentSuccess(r.data.payload.totalPrice); // google ads event
            KakaoPixel.Purchase(r.data.payload);
          })
          .catch(e => console.log('getOrderHistoryDetail e: ', e));
  }

  const getNonMemberDetail = (orderNumber: string) => {
    const customerName = localStorage.getItem('customerName');
    const customerPhone = localStorage.getItem('customerPhone');
    return getNotUserOrderDetail(orderNumber, {
      customerName: customerName!,
      customerPhone: customerPhone!,
    });
  };

  const getMemberDetail = (orderNumber: string) => {
    return getOrderHistoryDetail(orderNumber);
  };

  const orderCompleted = (order : TOrderDetail) => {
    var sub_total = 0, total_items_quantity = 0;

    getOrderHistory(0, 100).then(r => {
      setOrders(r?.data.payload.content || []);
    });

    orders.sort(function(first_order, second_order){
      return Number(first_order.orderNumber) - Number(second_order.orderNumber);
    })
    var total_sepnt = 0, cart_count = 0;
    orders.forEach((order) => {total_sepnt += order.totalPrice});
    getCarts().then((carts)=>carts.data.payload.carts.forEach(cart => {cart_count += cart.count}))

    Bridge.sendAmplitude('setUserProperties#first_order_date', new Date(orders[0].orderedAt!!));
    Bridge.sendAmplitude('setUserProperties#last_order_date', new Date(orders.reverse()[0].orderedAt!!));
    Bridge.sendAmplitude('setUserProperties#purchase_categories', []);
    Bridge.sendAmplitude('setUserProperties#total_cart_items_count', cart_count);
    Bridge.sendAmplitude('setUserProperties#total_orders', orders.length);
    Bridge.sendAmplitude('setUserProperties#total_spent_amount', total_sepnt);

    var items = order.products.map((product) => {
      sub_total += product.unitPrice;
      total_items_quantity += product.count;
      return {
        'item_id' : product.productId,
        'item_name' : product.productName,
        'item_category' : '?',
        'item_color' : product.color,
        'item_gender' : '?',
        'item_size' : product.sizeName,
        'item_price' : product.unitPrice,
        'item_discount_rate' : (1 - product.discountedUnitPrice! / product.unitPrice!) * 100,
        'item_discount_price' : product.discountedUnitPrice,
        'order_item_quantity' : product.count
      }
    });

    Bridge.sendAmplitude('total_items_order_completed', {
      'non_member_order' : isLoggedIn === true ? false : true,
      'items' : items,
      'total_order_items_quantity' : total_items_quantity,
      'sub_total' : sub_total,
      'payment_method' : order.payMethod.toString(),
      'paid_shipping' : order.deliveryPrice,
      'paid_point' : order.usedMileage,
      'coupon_id' : order.appliedCoupons.map(coupon => coupon.couponId).join(','),
      'coupon_name' : order.appliedCoupons.map(coupon => coupon.name).join(','),
      'reward_point' : order.earnedMileage,
      'order_id' : String(order.orderId),
      'order_total' : order.totalPrice
    });

    items.forEach(item =>
      Bridge.sendAmplitude('item_order_completed', {
        'item_id' : item.item_id,
        'item_name' : item.item_name,
        'item_category' : '?',
        'item_color' : item.item_color,
        'item_gender' : '?',
        'item_size' : item.item_size,
        'item_price' : item.item_price,
        'item_discount_rate' : item.item_discount_rate,
        'item_discount_price' : item.item_discount_price,
        'order_item_quantity' : item.order_item_quantity,
        'sub_total' : item.item_price * item.order_item_quantity,
        'non_member_order' : isLoggedIn == true ? false : true
      })
    );
  }
  const sendDataToBraze = (order: TOrderDetail) => {

    var converted_payment_method;
    if (swapPayMethod(order?.payMethod!) === "신용카드") {
      converted_payment_method = "CARD"
    }

    Bridge.sendAirbridge(AIRBRIDGE_EVENT.orderComplete, {
      value: order?.totalPrice,
      action: "일반",
      semanticAttributes: {
        transactionID: order?.orderId,
        inAppPurchased: isMobile,
        totalValue: order?.totalPrice,
        currency: "KRW",
        totalQuantity: order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
        products: order?.products
      }
    })

    var properties =
      {
        productId: '칼하트',
        price: Number(order.totalPrice),
        currencyCode: 'USD',
        quantity: 1,
        raffle_status: false,
        non_member_order: isLoggedIn ? false : true,
        item_id: order.products.map(p => {return String(p.productId)}).join(','),
        item_name: order.products.map(p => p.productName).join(','),
        item_category: order.products.map(p => '?').join(','),
        item_color: order.products.map(p => p.color).join(','),
        item_gender: order.products.map(p => '?').join(','),
        item_size: order.products.map(p => p.sizeName).join(','),
        item_price: order.products.map(p => p.unitPrice).join(','),
        item_discount_rate: order.products.map(p => (1 - p?.discountedUnitPrice! / p?.unitPrice!) * 100).join(','),
        item_discount_price: order.products.map(p => p.discountedUnitPrice).join(','),
        order_item_quantity: order.products.map(p => p.count).join(','),
        total_order_items_quantity: order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
        // payment_method: swapPayMethod(order?.payMethod!),
        payment_method: converted_payment_method,
        paid_shipping: order.deliveryPrice,
        paid_point: order.usedMileage,
        coupon_id: order.appliedCoupons?.map(c => c.couponId).join(','),
        coupon_name: order.appliedCoupons?.map(c => c.name).join(','),
        reward_point: order.earnedMileage,
        order_id: order.orderId.toString(),
        order_total: order?.totalPrice,
        CH_purchased_categories: '?',
        phone : localStorage.getItem('customerPhone')
      }
      Bridge.sendBraze(BRAZE_EVENT.PURCHASE, properties);
      TargetingGates.sendPurchase(order.products);
  }

  if (!orderResult) return null;
  return (
    <>
      <DirectoryBar text="홈, 장바구니" />

      <div className="flex flex-col items-center justify-center mt-6 md:mt-16 pb-40 px-4">
        <H5 className="text-32 text-gray-900 font-normal">주문 완료</H5>
        <p
          className="text-14 text-center my-6 max-w-md leading-relaxed"
          style={{ color: '#6D7684' }}>
          주문이 완료되었습니다. 이용해 주셔서 감사합니다.
          <br />
          비회원 주문하신 내역은 주문번호 조회를 통해 가능하니, 주문번호를
          메모해두세요! 가상계좌 결제시, 주문일시로부터 24시간 내 결제를
          해주셔야 하며, 24시간 이후에도 결제대기일 경우 자동취소됩니다.
        </p>
        {/* <span
          className="text-14 w-full max-w-lg mx-auto text-center"
          style={{
            color: '#FF6B6B',
            paddingTop: 10,
            paddingBottom: 10,
            backgroundColor: '#FFF5F5',
            marginBottom: 34,
          }}>
          비회원구매시 주문 취소 및 교환 / 환불의 경우 고객센터로
          연락부탁드립니다.
        </span> */}
        <div className="max-w-lg mx-auto w-full">
          <div className="flex justify-between border-b pb-6 mb-6">
            <H5>총 결제 금액</H5>
            <H3 className="font-semibold">
              ₩{orderResult.totalPrice.toLocaleString()}
            </H3>
          </div>

          <div className="space-y-4">
            <InfoItem
              title="주문일시"
              description={moment(orderResult.orderedAt).format(
                `YYYY.MM.DD hh:mm:ss`,
              )}
            />
            {orderResult.payMethod === 'VIRTUAL_ACCOUNT' && (
              <InfoItem
                title="결제기한"
                description={
                  mobile
                    ? stringToDate(orderResult.expiredAt!)
                    : moment(orderResult.expiredAt).format(
                      `YYYY.MM.DD hh:mm:ss`,
                    )
                }
              />
            )}
            <InfoItem
              title="주문서 번호"
              description={orderResult.orderNumber}
            />
            <InfoItem title="상품" description={orderResult.productNames} />
            <InfoItem
              title="결제수단"
              description={swapPayMethod(orderResult.payMethod)}
            />
            {orderResult.payMethod === 'VIRTUAL_ACCOUNT' && (
              <>
                <InfoItem
                  title="계좌번호"
                  description={`${orderResult.virtualAccountBank} ${orderResult.virtualAccountNumber}`}
                />
                <InfoItem
                  title="예금주명"
                  description={orderResult.virtualAccountOwner!}
                />
              </>
            )}
          </div>

          <div className={`grid ${isLoggedIn && 'md:grid-cols-2'} gap-4 mt-16`}>
            {isLoggedIn && (
              <Button
                to="/mypage/orders"
                text="주문 / 배송 조회"
                className="filled-brand-1"
              />
            )}
            <Button to="/" text="계속 쇼핑하기" className="outlined-gray-900"
              onClick={()=>{onClicKeepShopping('장바구니 결제 성공')}}/>
          </div>
        </div>
      </div>
    </>
  );
};

interface InfoItemProps {
  title: string;
  description: string;
}

export const InfoItem: FC<InfoItemProps> = ({ title, description }) => {
  return (
    <div className="text-14 flex justify-between">
      <p className="text-gray-500">{title}</p>
      <p className="">{description}</p>
    </div>
  );
};
